import { css, html } from "lit";
import { OmniElement } from "../../omni-element.js";
class OmniCardGrid extends OmniElement {
  static get styles() {
    return [
      ...super.styles,
      css`
        :host {
          --omni-card-min-width: auto;
          --omni-card-max-width: auto;
        }
        slot {
          display: grid;
          grid-template-columns: repeat(
            auto-fill,
            minmax(var(--omni-card-grid-col-min, 200px), var(--omni-card-grid-col-max, 1fr))
          );
          grid-gap: var(--omni-card-grid-gap, 24px);
        }
      `
    ];
  }
  render() {
    return html` <slot></slot> `;
  }
}
OmniElement.register("omni-card-grid", OmniCardGrid);
export {
  OmniCardGrid
};
//# sourceMappingURL=omni-card-grid.js.map
